/*
  Which Library banners about copying templates to Clio Work the user closed, per org. The intro
  stays closed; a job's results banner stays closed for that job only, so the next copy shows its own.
*/

const introKey = (orgFprint: string) =>
  `clioWorkCopyIntroDismissed:${orgFprint}`;
const resultsKey = (orgFprint: string) =>
  `clioWorkCopyResultsDismissed:${orgFprint}`;

export const isIntroDismissed = (orgFprint: string) =>
  window.localStorage.getItem(introKey(orgFprint)) === 'true';

export const dismissIntro = (orgFprint: string) => {
  window.localStorage.setItem(introKey(orgFprint), 'true');
};

export const isResultsDismissed = (orgFprint: string, jobId: number) =>
  window.localStorage.getItem(resultsKey(orgFprint)) === String(jobId);

export const dismissResults = (orgFprint: string, jobId: number) => {
  window.localStorage.setItem(resultsKey(orgFprint), String(jobId));
};
